<template>
  <div>
    <head-vue></head-vue>
    <bannerVue></bannerVue>
    <navVue></navVue>
    <div class="main">
      <router-view></router-view>
    </div>
    <foot-vue></foot-vue>
  </div>
</template>

<script>
import bannerVue from "./banner.vue";
import headVue from "./head.vue";
import navVue from "./nav.vue";
import footVue from "./foot.vue";
export default {
  components: {
    headVue,
    bannerVue,
    navVue,
    footVue,
  },
};
</script>

<style>
.main {
  position: relative;
  z-index: 10;
}
</style>
